<template>
  <bk-page class="purchaseHistoryPage" pageType="navPage" :navBarInfo="navBarInfo">
		<bk-view class="view-container">
      <bk-scroll-list 
        :beforeSearch="beforeSearch"  
        :async-load-data="requestGetPurchaseList" 
        emptyType="noData" 
        langCode_description="userInfo_memberRights_rightsDetail_description"
      >
        <template v-slot="{ dataList }">
           <bk-view class="view-purchaseDay-main" v-for="(item,index) in dataList" :key="index">
            <bk-title class="view-title" showLeftSign>
              <bk-date :date="item.date" :curShop="item.curShop"></bk-date>
            </bk-title>
            <bk-view class="view-purchase-list">
              <bk-view class="view-purchase-item" v-for="billItem in item.billList" :key="billItem.billId" @click="handleItemClick(billItem)">
                <bk-view class="view-header-main">
                  <bk-view class="view-name">{{billItem.compName}}</bk-view>
                  <bk-view class="view-billNo-main">
                    <bk-view>No.{{billItem.billNo}}</bk-view>
                    <bk-view class="view-date">
                      <bk-date :curShop="billItem" :date="billItem.settleDate" showHm></bk-date>
                      <bk-icon icon="icon-youjiantou" />
                    </bk-view>
                  </bk-view>
                </bk-view>
                <bk-view class="view-purchase-content">
                  <bk-view class="view-contnet-item" v-for="detailItem in billItem.detailList" :key="detailItem.goodsId">
                    <bk-view class="view-name">{{detailItem.goodsName}}</bk-view>
                    <bk-view class="view-right">
                      <bk-view class="view-num">x{{detailItem.quantity}}</bk-view>
                      <bk-price class="view-price" :value="detailItem.payAmount" fontSize="12px"></bk-price>
                    </bk-view>
                  </bk-view>
                </bk-view>
                <bk-view class="view-gst-content" v-if="billItem.costList?.length">
                  <bk-view class="view-contnet-item" v-for="costItem in billItem.costList" :key="costItem.id">
                    <bk-view class="view-name">{{costItem.showName}}</bk-view>
                    <bk-view class="view-right">
                      <bk-view class="view-num">{{costItem.rateText}}</bk-view>
                      <bk-price class="view-price" :value="costItem.amount"></bk-price>
                    </bk-view>
                  </bk-view>
                </bk-view>
                <bk-view class="view-footer-main">
                  <bk-title langCode="userInfo_purchaseHistory_total" />
                  <bk-price :value="billItem.totalAmount"></bk-price>
                </bk-view>
              </bk-view>
            </bk-view>
           </bk-view>
        </template>
      </bk-scroll-list>
     
    </bk-view>

    <transition name="rightFadeIn">
      <component :is="showPage" :curRows="curItem"  @close="setShowPage()" />
    </transition>
	</bk-page>
</template>

<script>
	import { customerReq } from '@/reqService';
	import paymentDetail from './paymentDetail/paymentDetail.vue';

	export default {
		name: 'purchaseHistory',
		components:{ paymentDetail },
		data (){
			return {
				showPage:'',
				navBarInfo: {
					langCode_title:'userInfo_purchaseHistory_title',
					backFlag: true,
				},
				curItem:{},
				userInfo:this.$bk_getUserInfo(),
				shopDetailInfo: this.$bk_getShopDetailInfo(),
			};
		},
		methods:{
			beforeSearch (params) {
				params.userId = this.userInfo.userId;

				if((window.kisDZFlag || window.oblissDZFlag || window.komoDZFlag) && this.shopDetailInfo?.custId){
					params.custId = this.shopDetailInfo.custId;
				}
        
				return params;
			},
			async requestGetPurchaseList (params) {
				let res = await customerReq.requestGetPurchaseList(this, params);
				return { data:res?.list, total: res?.page?.total };
			},
			setShowPage (showPage=''){
				this.showPage = showPage;
			},
			handleItemClick (row){
				this.curItem = row;
				this.setShowPage('paymentDetail');
			}
		}
		
	};
</script>

<style lang="less">
@import './purchaseHistory.less';
</style>